import { uploadBytes } from "firebase/storage";
import React, { useRef } from "react";
import { useUpdateAgentProfile } from "../../common/hooks/useAgents";
import { supportedImageTypes } from "../../common/utils/image.util";
import { agentAvatarFullRef, agentAvatarThumbnailRef } from "../../FirebaseBackend";
import { validateSupportedFiletype } from "../../utils/file.util";
import Button from "../Common/Buttons";

type Props = {
    agent: string | undefined;
};

async function uploadAgentAvatar(
    agentId: string,
    file: File,
): Promise<{ avatarFullPath: string; avatarThumbnailPath: string }> {
    validateSupportedFiletype(file.type, supportedImageTypes);
    const upload = await uploadBytes(agentAvatarFullRef(agentId), file);

    const avatarFullPath = upload.ref.fullPath;
    const avatarThumbnailPath = agentAvatarThumbnailRef(agentId).fullPath;

    if (!avatarFullPath || !avatarThumbnailPath) {
        throw new Error("Failed to upload agent profile picture");
    }

    return { avatarFullPath, avatarThumbnailPath };
}

const AgentUploadAvatar = function AgentUploadAvatar(props: Props) {
    const { agent } = props;

    const inputFileAvatar = useRef<HTMLInputElement>(null);
    const [isUploading, setIsUploading] = React.useState<boolean>(false);

    const { mutateAsync: updateProfile } = useUpdateAgentProfile();

    const uploadProfilePicture = async (file: File) => {
        if (!agent) {
            return;
        }
        setIsUploading(true);
        try {
            const { avatarFullPath, avatarThumbnailPath } = await uploadAgentAvatar(
                agent,
                file,
            );
            await updateProfile({
                json: { avatarFullPath, avatarThumbnailPath },
            });
            window.alert("Profile picture changed successfully!");
        } catch (error) {
            window.alert(error);
        } finally {
            setIsUploading(false);
        }
    };

    if (!agent) return null;
    return (
        <div>
            <input
                type="file"
                id="file"
                ref={inputFileAvatar}
                style={{ display: "none" }}
                onChange={(event) => {
                    const { files } = event.target;
                    if (files && files.length > 0) {
                        uploadProfilePicture(files[0]);
                    }
                }}
            />
            <Button
                showLoadingSpinner={isUploading}
                onClick={() => inputFileAvatar.current?.click()}
            >
                Upload profile picture
            </Button>
        </div>
    );
};

export default AgentUploadAvatar;
